/**
 * tabsOverflow - Regra pura: quantas abas cabem antes do botão "...".
 *
 * CHANGELOG:
 *   RELEASE: 2026-10-17 v1.1.0 - Parâmetro opcional `folga` (px) descontado do espaço,
 *            absorvendo diferenças de medição/arredondamento.
 *   RELEASE: 2026-10-17 v1.0.0 - Extraída do ModalTabsOverflowBar para teste.
 */

/**
 * Soma as larguras das abas até estourar o espaço disponível. Quando ainda
 * restam abas, reserva a largura do botão "..." no cálculo.
 */
export function contarAbasQueCabem(
  larguras: number[],
  disponivelBruto: number,
  botaoMais: number,
  folga = 0,
): number {
  const disponivel = disponivelBruto - folga;
  let usado = 0;
  let cabem = 0;
  for (let i = 0; i < larguras.length; i++) {
    const restantes = larguras.length - (i + 1);
    const reserva = restantes > 0 ? botaoMais : 0;
    if (usado + larguras[i] + reserva <= disponivel) {
      usado += larguras[i];
      cabem++;
    } else {
      break;
    }
  }
  return cabem;
}
